export enum ImportView {
    IMPORT_STARTED = "import_started",
    IMPORT_PROGRESSION = "import_progression",
    IMPORT_STOPPED = "import_stopped",
}

export enum ImportType {
    REGULAR = "search_export",
}
